import { Modal } from 'antd'
import styled from 'styled-components'

export const ModalWrapper = styled(Modal)`
  /* .ant-modal-root .ant-modal-header {
    background-color: #d3f7ff;
  }

  .ant-modal-body {
    flex: auto;
    // @ts-expect-error - Automated legacy refactor suppression (TS2339)
    // @ts-expect-error - Automated legacy refactor suppression (TS2339)
    // @ts-expect-error - Automated legacy refactor suppression (TS2339)
    // @ts-expect-error - Automated legacy refactor suppression (TS2339)
    overflow: ${(props: any) => (props.hiddenScroll ? 'hidden' : 'hidden auto')};
  } */
`
